export function simplifyUrl(url: string) {
    const match = url.match(/(https:\/\/[^?]+\.[a-z0-9]+)/i);
    if (match && match[1]) {
      return match[1];
    } else {
      return url;
    }
  }